import React, {useContext, useEffect} from 'react'  
import OrderContext from '../../../../context/OrderContext' 
import Loader from '../../../Loader/Loader'
const ModalShippingLabel = () => {  
    let {orderData, orderID, getOrderDataID,  downloadShippingLabel, closeModal, loader} = useContext(OrderContext)  
        function SLDownload(OrderID, shippingID){ 
            downloadShippingLabel(OrderID, shippingID) 
        }

        useEffect(() => { 
            const timer = setTimeout(
                () =>  getOrderDataID(orderID)
            , 500);  
        }, [ ]);

    return (
        <>
            <div className="modal-header">
                <h4 className="modal-title">Shipping Labels</h4>
                <button onClick={closeModal} className="btn btn-close"><i className="feather icon-x"></i></button> 
            </div>
            <div className="modal-content"> 
                {loader ? <Loader></Loader> : 
                    <> 
                    <table className="table table-striped  nowrap" >
                    <thead>
                        <tr>
                            <th></th>
                            <th>Id</th>
                            <th>Vendor</th>
                            <th>Tracking number</th> 
                            <th>Status</th> 
                            <th>Shipping label</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                    {orderData.data.shipping.map(shipping => (
                            <tr key={shipping.id}>
                                <td>
                                    <div className="thumb ml-3">
                                        <i className="feather icon-file-text"></i>
                                    </div> 
                                </td>
                                <td className="product-info">{shipping.id}</td>
                                <td className="product-info">{shipping.vendor.name}</td>
                                <td className="product-info">{shipping.trackingNumber}</td>
                                <td className="product-info">{shipping.status}</td>
                                <td className="product-info">
                                    {shipping.hasShippingLabel ?
                                    
                                    <>
                                        <button type="button"  className=" btn btn-outline-secondary" onClick={() =>  SLDownload(orderData.data.orderId , shipping.id)}>Download</button>
                                    </> : <span className="pcoded-badge label label-danger">Shipping Label not added</span>}
                                </td> 
                            </tr>
                        ))}
                    </tbody>
                    </table> 
                    </> 
                } 
            </div> 
        </>
    )
}

export default ModalShippingLabel